import { guidGenerator } from '../../utils/utils';
import CONSTANTS from '../../constants/constants';
import jsonConstants from '../../constants/jsonConstants';

export const init_Flowchart = (type: string, name: string) => {
  return {
    id: type.toLowerCase() + '-' + guidGenerator(),
    flowchartName: name,
    flowchartType: type,
    components: [],
    nodes: [],
    edges: [],
  };
};
export const init_DefaultComponent = () => {
  return {
    id: 'default-' + guidGenerator(),
    componentType: 'default',
  };
};
export const init_SignInComponent = () => {
  return {
    id: 'signIn-' + guidGenerator(),
    componentType: 'signIn',
    contentDefinition: { value: '', templatized: false},
    usernameType: 'email',
    username: '',
    keepMeSignedIn: 'true',
    showPasswordTextbox: 'true',
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
    links: {
      forgotPassword: false,
      otp: false,
      createNewAccount: false,
      localAccountSignIn: true,
      socialProviders: {
        employeeLogin: false,
        facebook: false,
        google: false,
        discord: false,
        linkedIn: false,
        weChat: false,
      },
    },
    nodeLinks: [],
    formSubmitAction: {
      displayName: '',
      id: '',
    },
    validationErrorMessage: ''
  };
};

export const init_AADCreateComponent = () => {
  return {
    id: 'aadCreate-' + guidGenerator(),
    componentType: 'aadCreate',
    indexProperty: { id: 'email', dataType: 'string', claim: '' },
    attributes: [
      {
        id: 'displayName',
        claim: '',
        claimOrFunc: '',
      },
      {
        id: 'password',
        claim: '',
        claimOrFunc: '',
      },
    ],
    attribute: {
      id: '',
      claim: '',
    },
    mapObjectId: true,
    mapUserPrincipalName: false,
    mappedClaim: '',
    upnClaim: '',
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};

export const init_AADUpdateComponent = () => {
  return {
    id: 'aadUpdate-' + guidGenerator(),
    componentType: 'aadUpdate',
    indexProperty: { id: 'objectid', dataType: 'string', claim: '' },
    attributes: [],
    attribute: {
      id: '',
      claim: '',
    },
    mapObjectId: true,
    mappedClaim: '',
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};

export const init_GoogleComponent = () => {
  return {
    id: 'google-' + guidGenerator(),
    componentType: 'google',
    attributes: [],
    extraOutputClaims: [],
    attribute: {
      id: '',
      claim: '',
    },
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};

export const init_AADReadComponent = () => {
  return {
    id: 'aadRead-' + guidGenerator(),
    componentType: 'aadRead',
    indexProperty: { id: 'objectid', dataType: 'string', claim: '' },
    attributes: [],
    attribute: {
      id: '',
      claim: '',
    },
    throwErrorIfNotFound: true,
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};

export const init_UserInputPageComponent = (name = 'userInputPage') => {
  return {
    id: name + '-' + guidGenerator(),
    componentType: 'userInputPage',
    contentDefinition: { value: '', templatized: false},
    attributes: [],
    attribute: {
      attributeName: '',
      readOnly: false,
      prefillValue: 'fromAnotherAttribute',
      attributeSource: '',
      defaultValue: '',
      sessionContext: CONSTANTS.SESSIONCONTEXT[0]['value'],
      required: false,
      repeatField: false,
    },
    validateEmail: false,
    email: {
      valEmailType: 'newEmail',
      newEmail: {
        attributeSource: '',
        prefillValue: false,
      },
      valPrevEmail: {
        emailAttribute: '',
        editEmail: false,
      },
      expiryTime: 10,
      configureApi: { value: false, disabled: true },
    },
    formSubmitAction: {
      displayName: '',
      id: '',
    },
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
    validationErrorMessage: ''
  };
};

export const init_AppInsightsComponent = () => {
  return {
    id: 'appInsights-' + guidGenerator(),
    componentType: 'appInsights',
    eventType: '',
    instrumentationKey: { value: '', templatized: false},
    claims: [],
    attribute: {
      claimId: '',
      partnerClaimType: '',
      defaultValue: '',
      type: '',
    },
  };
};

export const init_RESTAPIComponent = () => {
  return {
    id: 'restAPI-' + guidGenerator(),
    componentType: 'restAPI',
    parameters: [],
    parameter: {
      type: 'input',
      sourceType: 'claim',
      parameterName: '',
      claimName: '',
      defaultValue: '',
      alwaysUseDefaultValue: false,
    },
    authenticationType: 'none',
    serviceUrl: { value: '', templatized: false },
    sendClaimsIn: 'body',
    clientIdContainer: { value: '', templatized: false },
    clientSecretContainer: { value: '', templatized: false },
    issuerTenant: { value: '', templatized: false },
    applicationIdUri: { value: '', templatized: false },
    clientCertContainer: { value: '', templatized: false },
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};

export const init_ConditionalComponent = () => {
  return {
    id: 'conditionals-' + guidGenerator(),
    componentType: 'conditionals',
    condition: {
      claim: '',
      comValue: '',
      compareTo: 'literal',
      operator: '==',
      option: 'ignorecase',
    },
    groups: [],
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};

export const init_ValidateMagicLink = () => {
  return {
    id: 'validateMagicLink-' + guidGenerator(),
    componentType: 'validateMagicLink',
    email: '',
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};

export const init_TokenIssuer = () => {
  return {
    id: 'tokenIssuer-' + guidGenerator(),
    componentType: 'tokenIssuer',
    protocol: 'oidc',
    issuerUri: { value: '', templatized: false },
    attributes: [],
    attribute: {
      attributeName: '',
      defaultValue: '',
      alwaysUseDefaultValue: false,
      partnerClaimType: ''
    },
    subClaim: '',
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
    ssoScope: { value: 'Tenant', templatized: false },
    ssoExpiryType: { value: 'Rolling', templatized: false },
    ssoExpiryTime: { value: '86400', templatized: false}
  };
};

export const init_UserInfoIssuer = () => {
  return {
    id: 'userInfoIssuer-' + guidGenerator(),
    componentType: 'userInfoIssuer',
    attributes: [],
    attribute: {
      attributeName: '',
      defaultValue: '',
      alwaysUseDefaultValue: false,
    },
    subClaim: '',
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};

export const init_AuthorizeToken = () => {
  return {
    id: 'authorizeToken-' + guidGenerator(),
    componentType: 'authorizeToken',
    oidcApplicationId: { value: '', templatized: false },
    claims: [],
  };
};

export const init_MFAAuth = () => {
  return {
    id: 'mfa-' + guidGenerator(),
    componentType: 'mfa',
    contentDefinition: { value: '', templatized: false},
    mode: 'alwaysNew',
    phoneNumberClaim: '',
    idClaim: '',
    enteredPhoneNumberClaim: '',
    newNumberFlagClaim: '',
    stepUpEnabled: false,
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
    altSessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    }
  };
};

export const init_UsernamePasswordValidation = () => {
  return {
    id: 'usernamePasswordValidation-' + guidGenerator(),
    componentType: 'usernamePasswordValidation',
    claim: 'objectId',
    errorMsg: 'Username password is invalid. Please re-enter your credentials.',
    usernameType: 'email',
    username: '',
    password: 'password',
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};

export const init_WebAuthnRegistration = () => {
  return {
    id: 'webAuthnRegistration-' + guidGenerator(),
    componentType: 'webAuthnRegistration',
    apiUrl: '',
    idClaim: '',
    nameClaim: '',
    displayNameClaim: '',
    successClaim: '',
    contentDefinition: { value: '', templatized: false},
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};

export const init_WebAuthnAuthentication = () => {
  return {
    id: 'webAuthnAuthentication-' + guidGenerator(),
    componentType: 'webAuthnAuthentication',
    apiUrl: '',
    idClaim: '',
    successClaim: '',
    contentDefinition: { value: '', templatized: false},
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};

export const init_WebAuthnCredentialsExist = () => {
  return {
    id: `webAuthnCredentialsExist-` + guidGenerator(),
    componentType: 'webAuthnCredentialsExist',
    existsClaim: '',
    contentDefinition: { value: '', templatized: false},
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};
export const init_WebAuthnAvailability = () => {
  return {
    id: `webAuthnAvailability-` + guidGenerator(),
    componentType: 'webAuthnAvailability',
    availabilityClaim: '',
    requirePlatformAuth: true,
    contentDefinition: { value: '', templatized: false},
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};
export const init_ConditionalAccessEvaluation = () => {
  return {
    id: `conditionalAccessEvaluation-` + guidGenerator(),
    componentType: 'conditionalAccessEvaluation',
    idClaim: '',
    mfaRegisteredClaim: '',
    changePasswordChallenge: '',
    mfaChallenge: '',
    blockChallenge: '',
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};
export const init_ConditionalAccessRemediation = () => {
  return {
    id: `conditionalAccessRemediation-` + guidGenerator(),
    componentType: 'conditionalAccessRemediation',
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  };
};
export const init_ErrorPage = () => {
  return {
    id: `errorPage-` + guidGenerator(),
    componentType: 'errorPage',
    contentDefinition: { value: '', templatized: false},
  };
};

export const init_SendEmailOTP = () => {
  return {
    id: `sendEmailOTP-` + guidGenerator(),
    componentType: 'sendEmailOTP',
    otpField: 'otp',
    language: {
      source: '',
      sourceType: '',
    },
    fields: [],
    emailClaim: '',
    templateName: '',
  };
};

export const init_SessionExists = () => {
  return {
    id: `sessionExists-` + guidGenerator(),
    componentType: 'sessionExists',
  };
};

export const init_oidcIdP = () => {
  return {
    id: `oidcIdP-` + guidGenerator(),
    componentType: 'oidcIdP',
    idpDomain: { value: '', templatized: false},
    metadataUrl: { value: '', templatized: false},
    authEndpointUrl: { value: '', templatized: false},
    endSessionEndpointUrl: { value: '', templatized: false},
    clientId: { value: '', templatized: false},
    responseType: '',
    clientSecretContainerName: { value: '', templatized: false},
    responseMode: '',
    inputClaims: [],
    issuerIdPartnerClaimType: '',
    outputClaims: [],
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    },
  }
}

export const init_validationError = () => {
  return {
    id: `validationError-` + guidGenerator(),
    componentType: 'validationError'
  }
}

export const init_samlIdP = () => {
  return {
    id: `samlIdP-` + guidGenerator(),
    componentType: 'samlIdP',
    idpDomain: { value: '', templatized: false},
    metadataUrl: { value: '', templatized: false},
    signRequests: true,
    messageSigningKey: { value: '', templatized: false},
    signatureAlgorithm: 'Sha1',
    responseSignatures: true,
    assertionsEncrypted: false,
    assertionDecryptionKey: { value: '', templatized: false},
    metadataSigningKey: { value: '', templatized: false},
    requestUser: false,
    requestUserClaim: '',
    issuerIdPartnerClaimType: '',
    outputClaims: [],
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: '',
    }
  }
}

export const init_setClaims = () => {
  return {
    id: `setClaims-` + guidGenerator(),
    componentType: 'setClaims',
    setClaims: {},
    sessionManagement: {
      option: 'alwaysExecute',
      sessionId: ''
    }
  }
}
